// Single source of truth for supported languages.
// Codes match the keys used in multi-language JSON content columns
// (ci_products.product_title etc.), so they must stay UPPERCASE.

export const LANGUAGES = [
  { code: 'EN', name: 'English', nativeName: 'English' },
  { code: 'LV', name: 'Latvian', nativeName: 'Latviešu' },
  { code: 'RU', name: 'Russian', nativeName: 'Русский' },
  { code: 'FR', name: 'French', nativeName: 'Français' },
  { code: 'DE', name: 'German', nativeName: 'Deutsch' },
  { code: 'EE', name: 'Estonian', nativeName: 'Eesti' },
  { code: 'LT', name: 'Lithuanian', nativeName: 'Lietuvių' },
  { code: 'IT', name: 'Italian', nativeName: 'Italiano' },
  { code: 'ES', name: 'Spanish', nativeName: 'Español' },
  { code: 'PT', name: 'Portuguese', nativeName: 'Português' },
];

export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code);

export const DEFAULT_LANGUAGE = 'EN';

/** localStorage key for visitor language preference */
export const APP_LANGUAGE_STORAGE_KEY = 'app_language';

/**
 * Default storefront i18n config (overridden by admin configs.i18n).
 * switcherEnabled: master on/off for LanguageSwitcher
 * languagesInSwitcher: which of the 10 codes appear in the dropdown
 *
 * The default is OFF, and deliberately so: this is what renders before
 * `/api/config` answers, and what a failed request falls back to. A shop that
 * has not turned the other languages on yet must not show them for the first
 * few hundred milliseconds of every page load — the visitor's pick is
 * persisted to localStorage, so one blind click during that window would stick
 * with no switcher left to undo it. Turning languages on is an explicit act.
 */
export const DEFAULT_I18N_CONFIG = {
  switcherEnabled: false,
  defaultLanguage: DEFAULT_LANGUAGE,
  languagesInSwitcher: [DEFAULT_LANGUAGE],
};
